import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

import ColumnSelector from 'bundles/research/index/properties/columns/selector';
import ColumnSelectorButton from 'bundles/research/index/components/column_selector_button';
import SidebarSearch from 'components/search_sidebar/sidebar_search';
import ViewToggle from 'bundles/research/index/properties/view_toggle';

import { changeSearchText, clearFiltersIfEmpty } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import ResearchSavedSearchTopbar from '../searches/saved_search_topbar';

export class ResearchFilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    currentTab: PropTypes.string.isRequired,
    delayRetrieveRecords: PropTypes.func,
    edgeCrm: PropTypes.bool,
    hideOverlayFilters: PropTypes.func.isRequired,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired,
    }),
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    searchPlaceholder: 'Search by name, address, city, state, zip',
  };

  handleSearchChange = (e) => {
    const { onSearchChange } = this.props;
    onSearchChange(e.target.value);
    this.handleRetrieveRecords();
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  render() {
    return (
      <div className="d-flex flex-column flex-lg-row gap-2 flex-wrap">
        <div className="d-flex gap-2 align-items-center flex-fill">
          {this.renderSearchBar()}
          <div className="d-none d-lg-flex">{this.props.children}</div>
        </div>

        <div className="d-flex gap-2">
          {this.props.edgeCrm && this.props.currentTab !== 'maps' && (
            <ColumnSelectorButton
              hide={this.props.showColumnFilters}
              onClose={this.props.hideOverlayFilters}
              onOpen={this.props.showOverlayFilters}
            >
              <ColumnSelector />
            </ColumnSelectorButton>
          )}
          {this.props.edgeCrm && (
            <div className="d-none d-lg-block">
              <ViewToggle />
            </div>
          )}
        </div>

        {!this.props.edgeCrm && (
          <div className="d-inline-block">
            <ResearchSavedSearchTopbar />
          </div>
        )}
      </div>
    );
  }

  renderSearchBar() {
    const { searchPlaceholder, searchText } = this.props;

    return (
      <SidebarSearch
        additionalClasses="flex-shrink-0 flex-grow-1 flex-lg-grow-0"
        inputProps={{
          name: 'search_text',
          className: 'flex-grow-1',
        }}
        placeholder={searchPlaceholder}
        value={searchText}
        onChange={this.handleSearchChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentTab: state.ui.currentTab,
  groups: state.properties.groups,
  searchText: state.query.searchText,
  showColumnFilters: state.ui.showColumnFilters,
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  hideOverlayFilters,
  onSearchChange: changeSearchText,
  showOverlayFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchFilterRow);
